module.exports = __webpack_public_path__ + "img/2.ae0a1d20.png";